import {
  createFrontendPlugin,
  PageBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiRobot2Fill } from '@remixicon/react';
import { rootRouteRef, costCodeRouteRef, historyRouteRef } from './routes';

const bobPage = PageBlueprint.make({
  params: {
    title: 'Bulk Operations Bot (BOB)',
    icon: <RiRobot2Fill />,
    path: '/bob',
    routeRef: rootRouteRef,
  },
});

const costCodeSubPage = SubPageBlueprint.make({
  name: 'cost-code',
  params: {
    path: 'cost-code',
    title: 'Cost Code',
    routeRef: costCodeRouteRef,
    loader: () =>
      import(
        './components/cost-code-migration-tab/cost-code-migration-tab'
      ).then(m => <m.CostCodeMigrationTab />),
  },
});

const historySubPage = SubPageBlueprint.make({
  name: 'history',
  params: {
    path: 'history',
    title: 'History',
    routeRef: historyRouteRef,
    loader: () =>
      import('./components/migration-history-tab/migration-history-tab').then(
        m => <m.MigrationHistoryTab />,
      ),
  },
});

export const bobPlugin = createFrontendPlugin({
  pluginId: 'bob',
  extensions: [bobPage, costCodeSubPage, historySubPage],
  routes: {
    root: rootRouteRef,
  },
});
